import CustomInput from "../../../components/CustomInput";
import CustomSelect from "../../../components/CustomSelect";
import SubHeadings from "../../../components/SubHeadings";
import { Student } from "../../../types/studentType";
import { useFormEdit } from "../../../util/hooks/useFormEdit";

interface familyInformationProps {
  form: ReturnType<typeof useFormEdit<Student>>;
}

export default function FamilyDetails({ form }: familyInformationProps) {
  const { formData, setFormData, isEditing } = form
   
  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value, type } = event.target;
    const newValue = type === "radio" ? value : value;
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  return (
    <div className="px-4 md:px-9 flex flex-col py-7 gap-9">
      <div className="flex justify-between items-center">
        <SubHeadings text="Family Details" />
      </div>
      <form className="grid gap-7">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          <CustomInput
            name="fatherFullName"
            label="Father name"
            readOnly={!isEditing}
            type="text"
            placeholder="Enter Father name"
            value={formData.fatherFullName ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="fatherPhoneNumber"
            label="Father phone number"
            type="tel"
            readOnly={!isEditing}
            placeholder="Enter Father phone number"
            value={formData.fatherPhoneNumber ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="fatherEmail"
            label="Father email"
            type="email"
            readOnly={!isEditing}
            placeholder="Enter Father email"
            value={formData.fatherEmail ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="fatherOccupation"
            label="Father occupation"
            type="text"
            readOnly={!isEditing}
            placeholder="Enter Father occupation"
            value={formData.fatherOccupation ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="motherFullName"
            label="Mother name"
            readOnly={!isEditing}
            type="text"
            placeholder="Enter Mother name"
            value={formData.motherFullName ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="motherPhoneNumber"
            label="Mother phone number"
            type="tel"
            readOnly={!isEditing}
            placeholder="Enter Mother phone number"
            value={formData.motherPhoneNumber ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="motherEmail"
            label="Mother email"
            type="email"
            readOnly={!isEditing}
            placeholder="Enter Mother email"
            value={formData.motherEmail ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="motherOccupation"
            label="Mother occupation"
            type="text"
            readOnly={!isEditing}
            placeholder="Enter Mother occupation"
            value={formData.motherOccupation ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="languageSpokenAtHome"
            label="Language spoken at home"
            type="text"
            readOnly={!isEditing}
            placeholder="Enter the common  language used at home"
            value={formData.languageSpokenAtHome ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />
        </div>

        <div className="grid gap-4 md:items-center w-full">
          <CustomInput
            name="residentialAddress"
            label="Residential address"
            type="text"
            readOnly={!isEditing}
            placeholder="Enter full permanent address"
            value={formData.residentialAddress ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          <CustomInput
            name="emergencyContactName"
            label="Emergency contact name"
            type="text"
            readOnly={!isEditing}
            placeholder="Enter Emergency contact name"
            value={formData.emergencyContactName ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="emergencyContactNumber"
            label="Emergency contact number"
            type="tel"
            readOnly={!isEditing}
            placeholder="Enter Emergency contact number"
            value={formData.emergencyContactNumber ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomSelect
            name="familyType"
            label="Family type"
            readOnly={!isEditing}
            options={["Nuclear","Joint","Single Parent"]}
            placeholder="Enter family type"
            value={formData.familyType ?? ""}
            onChange={handleInputChange}
            selectClassName="w-full"
          />
        </div>
      </form>
    </div>
  );
}
